import '../../css/style.scss'
import {EntryHomepage} from '../EntryHomepage'
import {UIGameSpriteHandler} from '../../../shared/scripts/UIGameSpriteHandler'
import {UIReplayController} from '../../../shared/scripts/ui_replay/UIReplayController'
import {getReplayInitiationData, getReplayUrlActionIndex} from '../../../shared/scripts/ui_replay/ReplayUrlUtilities'

class EntryReplay extends EntryHomepage {
    async initialize() {
        await super.initialize()

        void UIGameSpriteHandler.continueAfterAssetsLoad(async() => {
            const href = window.location.href
            const replayInitiationData = await getReplayInitiationData(href)
            const replayActionIndex = getReplayUrlActionIndex(href)
            const isLiveReplay = false
            new UIReplayController(replayInitiationData, this.socketActionController, isLiveReplay, replayActionIndex)
        })
    }
}

const replay = new EntryReplay()
void replay.initialize()
